<template>
  <div class="combine-container simple-search-table-container default-table">
    <div class="head">
      <div>
        <el-input v-model="queryParams.name" placeholder="模糊查询客户集团名称" size="mini"/>
        <el-button type="primary" size="mini" @click="handelSearch">查询</el-button>
      </div>
      <div>
        <el-button v-if="userAuth.manage_year_frame_apply" size="mini" type="primary" @click="goYearFrame">年框申请列表
        </el-button>
        <el-button v-if="userAuth.can_add_combine" type="primary" size="mini" @click="handelCreate">新增客户集团
        </el-button>
      </div>
    </div>

    <ApeTable ref="apeTable" :data="tableData" :loading="loading" :paging-data="configPage" @switchPaging="getTableData"
              highlight-current-row border is-full-height>
      <el-table-column prop="name" label="客户集团名称" header-align="center" align="center" min-width="160"
                       :show-overflow-tooltip="true"/>
      <el-table-column label="年框" header-align="center" align="center" min-width="120">
        <template slot-scope="scope">
          <template v-if="scope.row.year_frame === 'N'">
            <i class="el-icon-star-off"/>非年框
            <el-button v-if="userAuth.can_year_frame_add" type="text" size="mini"
                       @click="toApplyYearFrame(scope.row)">申请
            </el-button>
          </template>
          <template v-else-if="scope.row.year_frame === 'Y'">
            <i class="el-icon-star-on"/>年框
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="level_combine" label="客户集团等级" header-align="center" align="center" min-width="120"/>
      <el-table-column prop="sign_begin" label="签约开始" header-align="center" align="center" min-width="120"/>
      <el-table-column prop="sign_end" label="签约截止" header-align="center" align="center" min-width="120"/>
      <el-table-column prop="created_at" label="创建时间" header-align="center" align="center" min-width="120"/>
      <el-table-column prop="updated_at" label="修改时间" header-align="center" align="center" min-width="120"/>
      <el-table-column label="操作" header-align="center" align="center" min-width="120">
        <template slot-scope="{row}">
          <el-button v-if="userAuth.can_update_combine" type="text" size="mini" icon="el-icon-edit"
                     @click="handelUpdate(row)">修改
          </el-button>
          <el-button v-if="userAuth.can_delete_combine" type="text" size="mini" icon="el-icon-delete"
                     @click="handelDelete(row)">删除
          </el-button>
        </template>
      </el-table-column>
    </ApeTable>

    <el-dialog :title="formStore.type==='CREATE'?'新增客户集团':'编辑客户集团'" :visible.sync="dialogStore"
               width="580px"
               center>
      <el-input v-model="formStore.name" placeholder="请输入客户集团名称" maxlength="50" show-word-limit/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStore = false">取 消</el-button>
        <el-button type="primary" @click="handelStoreSure">确 定</el-button>
      </span>
    </el-dialog>
    <apply-year-frame ref="applyYearFrame" :show.sync="applyYearFrameDialog" :customer="applyYearFrameTheCustomer"
                      :type="'TO_Y'" aim="COMBINE"/>
  </div>
</template>

<script>
import ApeTable from "@/components/ApeTable.vue";
import {combineCustomerDelete, combineCustomerPage, combineCustomerStore} from "@/api/combine";
import ApplyYearFrame from "../../custom/components/yearFrame/apply.vue";

const ModelFormStore = {
  type: 'CREATE',
  name: null,
  id: null,
}
const ConfigPage = {
  is_show: true,
  layout: 'total, sizes, prev, pager, next, jumper',
  total: 0,
  page_size: 30,
  page: 1,
}
export default {
  name: "index",
  components: {ApeTable, ApplyYearFrame},
  data() {
    return {
      configPage: ConfigPage,
      loading: false,
      dialogStore: false,
      applyYearFrameDialog: false,
      applyYearFrameTheCustomer: false,
      formStore: {...{}, ...ModelFormStore},
      queryParams: {name: null},
      tableData: []
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    handelCreate() {
      this.formStore = {...{}, ...ModelFormStore}
      this.dialogStore = true;
    },
    handelUpdate(obj) {
      this.formStore = {
        type: 'UPDATE',
        name: obj.name,
        id: obj.id,
      }
      this.dialogStore = true;
    },
    handelDelete(obj) {
      this.showModal({
        h: this,
        text: `确认删除【${obj.name}】吗？`,
        confirmText: "",
        cancelText: "",
        confirm: async () => {
          const response = await combineCustomerDelete({id: obj.id})
          if (!response.success) {
            this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
            return;
          }
          this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
          await this.getTableData()
        }
      });
    },
    async handelStoreSure() {
      if (!this.formStore.name) {
        this.showToast({h: this, icon: "el-icon-error", text: '请填写客户集团名称', duration: 2000});
        return false;
      }
      const response = await combineCustomerStore(this.formStore)
      if (!response.success) {
        this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
        return;
      }
      this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
      await this.getTableData()
      this.dialogStore = false;
    },
    handelSearch() {
      this.getTableData(true)
    },
    getParams(isSearch) {
      let pageInfo = this.$refs['apeTable'].getPagingInfo()
      const params = {...this.queryParams, ...pageInfo}
      params.page = isSearch ? 1 : pageInfo.current_page
      return params
    },
    async getTableData(isSearch = false) {
      const response = await combineCustomerPage(this.getParams(isSearch))
      this.tableData = response.model.data || []
      this.configPage.total = response.model.total || 0
    },
    async toApplyYearFrame(obj, type = 'TO_Y') {
      obj = {...{}, ...obj}
      this.applyYearFrameTheCustomer = obj;
      this.applyYearFrameDialog = true;
      this.applyYearFrameTheCustomer.combine_id = obj.id;
      this.applyYearFrameTheCustomer.combine_name = obj.name;
      this.applyYearFrameTheCustomer.type = type;
    },
    goYearFrame() {
      this.$router.push({path: '/project/yearFrameProposer', query: {hand: 'proposer'}})
    }
  }
}
</script>

<style lang="scss">
.combine-container {
  padding: 24px;

  .head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .el-input {
      width: 250px;
      margin-right: 12px;
    }
  }

  .el-table {
    margin-bottom: 10px;
  }
}
</style>
